var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-select',{attrs:{"value":_vm.value,"clearable":""},on:{"change":_vm.handleChange}},_vm._l((_vm.dictData),function(item,index){return _c('el-option',_vm._b({key:index},'el-option',item,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }